import { render, staticRenderFns } from "./ExpireAlert.vue?vue&type=template&id=f2f1f0bc&scoped=true&"
import script from "./ExpireAlert.vue?vue&type=script&lang=js&"
export * from "./ExpireAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f1f0bc",
  null
  
)

export default component.exports